// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 737) return "737.8a69546be755f070.web-search.js";
	if (chunkId === 182) return "182.14d00e1daa56c81a.web-search.js";
	// return url for filenames based on template
	return undefined;
};